import axios from 'axios'

const state = {
  lista: [],
  textoPesquisa: '',
  situacao: '9', // 9=Todos, 1=Ativo, 0=Inativo
  tipo: '0', // 0=Todos, 1-8 = Tipos conforme combo
  registroSelecionadoId: null,
  recarregarLista: false,
  
  // Abastecimentos
  listaAbastecimentos: [],
  dataInicioAbastecimento: null,
  dataFimAbastecimento: null,
  
  // Manutenções
  listaManutencoes: [],
  dataInicioManutencao: null,
  dataFimManutencao: null
}

const mutations = {
  SET_LISTA (state, payload) {
    state.lista = payload
  },
  SET_TEXTO_PESQUISA (state, payload) {
    state.textoPesquisa = payload
  },
  SET_SITUACAO (state, payload) {
    state.situacao = payload
  },
  SET_TIPO (state, payload) {
    state.tipo = payload
  },
  SET_REGISTRO_SELECIONADO_ID (state, payload) {
    state.registroSelecionadoId = payload
  },
  SET_RECARREGAR_LISTA (state, payload) {
    state.recarregarLista = payload
  },
  SET_LIMPAR (state) {
    state.textoPesquisa = ''
    state.situacao = '9'
    state.tipo = '0'
  },
  
  // Abastecimentos
  SET_LISTA_ABASTECIMENTOS (state, payload) {
    state.listaAbastecimentos = payload
  },
  SET_DATA_INICIO_ABASTECIMENTO (state, payload) {
    state.dataInicioAbastecimento = payload
  },
  SET_DATA_FIM_ABASTECIMENTO (state, payload) {
    state.dataFimAbastecimento = payload
  },
  
  // Manutenções
  SET_LISTA_MANUTENCOES (state, payload) {
    state.listaManutencoes = payload
  },
  SET_DATA_INICIO_MANUTENCAO (state, payload) {
    state.dataInicioManutencao = payload
  },
  SET_DATA_FIM_MANUTENCAO (state, payload) {
    state.dataFimManutencao = payload
  }
}

const actions = {
  GET_LISTA ({ state }) {
    return new Promise((resolve, reject) => {
      let filtros = {
        textoPesquisa: state.textoPesquisa,
        situacao: state.situacao,
        tipo: state.tipo
      }

      axios.post('/api/protected/veiculo/pesquisar', filtros)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  
  GET_LISTA_ABASTECIMENTOS ({ state }, veiculoId) {
    return new Promise((resolve, reject) => {
      let params = {}
      if (state.dataInicioAbastecimento && state.dataFimAbastecimento) {
        params.dataInicio = state.dataInicioAbastecimento
        params.dataFim = state.dataFimAbastecimento
      }

      axios.get(`/api/protected/veiculo/abastecimento/listar/${veiculoId}`, { params })
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  
  GET_LISTA_MANUTENCOES ({ state }, veiculoId) {
    return new Promise((resolve, reject) => {
      let params = {}
      if (state.dataInicioManutencao && state.dataFimManutencao) {
        params.dataInicio = state.dataInicioManutencao
        params.dataFim = state.dataFimManutencao
      }

      axios.get(`/api/protected/veiculo/manutencao/listar/${veiculoId}`, { params })
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  }
}

const getters = {
  lista: state => state.lista,
  textoPesquisa: state => state.textoPesquisa,
  situacao: state => state.situacao,
  tipo: state => state.tipo,
  registroSelecionadoId: state => state.registroSelecionadoId,
  recarregarLista: state => state.recarregarLista,
  listaAbastecimentos: state => state.listaAbastecimentos,
  dataInicioAbastecimento: state => state.dataInicioAbastecimento,
  dataFimAbastecimento: state => state.dataFimAbastecimento,
  listaManutencoes: state => state.listaManutencoes,
  dataInicioManutencao: state => state.dataInicioManutencao,
  dataFimManutencao: state => state.dataFimManutencao
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/vuex/modulos/veiculo-store.js